import React from "react";
import styles from "./OutgoingChatBox.module.scss"
import ChatMessage from "./ChatMessage";
import { connect } from "react-redux";
import Passage from "../../domain/Passage";
import Message from "../../domain/Message";

function OutgoingChatBox(props) {

  let messagesToSend = [];
  if (props.currentPassage) messagesToSend = _.shuffle(props.currentPassage.possibleOutgoingMessages);

  return <div className={styles.container}>
    <div className={styles.textInput}>
      {_.isEmpty(props.scheduledMessages) &&
      messagesToSend.map(message =>
        <ChatMessage
          onClick={() => props.storyDispatch.sendMessage(message)}
          className={styles.possibleMessage}
          key={message.id}
          message={message}/>)
      }
    </div>
    {props.showSkip ? <div className={styles.skipButton} onClick={
      () => props.storyDispatch.receivePendingMessagesInstantly()}>
      Skip
    </div> : <div className={styles.sendButton}>Send</div>}
  </div>
}

const mapState = (state, props) => {
  const storyName = props.storyName;
  const passage = state[storyName].currentPassage;
  const scheduledMessages = state[storyName].scheduledMessages;
  return {
    currentPassage: passage && new Passage(passage),
    scheduledMessages,
    showSkip: scheduledMessages.length > 0 && scheduledMessages[0].message.isAwayMessage
  };
};

const mapDispatch = (state, props) => {
  const storyDispatch = state[props.storyName];
  return { storyDispatch };
};

export default connect(mapState, mapDispatch)(OutgoingChatBox);